import utils = egr.wcf.utils;
import { ios } from '../../submodules/utils/UserAgent';
import { appInfo } from '../../submodules/app-api/Information';
import { arPreview } from '../../submodules/app-api/AppAction';
import { DownloadHelper } from '../../utils/DownloadHelper';
import { UIHelper } from '../../utils/UIHelper';

export async function startAR(): Promise<void> {
    if (
        ARisAvailable()
    ) {
        const exportUrl: string | null = ios ?
            await DownloadHelper.getExportUrl('USDZ') :
            await DownloadHelper.getExportUrl('GLB');

        if (utils.string.isNullOrEmpty(exportUrl)) {
            UIHelper.showMessage('Action failed');
        } else {
            await arPreview(exportUrl);
        }
    }
}

export function ARisAvailable(): boolean {
    return (
        appInfo != null &&
        appInfo.ar_device === true &&
        window.ReactNativeWebView != null
    );
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ar/ARUtils.ts